<div class='container profile' *ngIf="initialized">
  <app-header></app-header>
  <router-outlet></router-outlet>
</div>